import { render, staticRenderFns } from "./IconSpinner.vue?vue&type=template&id=5dca53c7&scoped=true&"
import script from "./IconSpinner.vue?vue&type=script&lang=js&"
export * from "./IconSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dca53c7",
  null
  
)

export default component.exports